export const MAX_QYOO_ID = (1n << 36n) - 1n;
export const MAX_QYOO_ID_NUMBER = Number(MAX_QYOO_ID);

export class InvalidQyooIdError extends Error {
  constructor(value: unknown) {
    super(`Invalid 36-bit Qyoo ID: ${String(value)}`);
    this.name = "InvalidQyooIdError";
  }
}

export function parseQyooId(value: string | number | bigint): number {
  let parsed: bigint;
  try {
    if (typeof value === "string") {
      if (!/^(0|[1-9][0-9]*)$/.test(value)) throw new InvalidQyooIdError(value);
      parsed = BigInt(value);
    } else if (typeof value === "number") {
      if (!Number.isSafeInteger(value)) throw new InvalidQyooIdError(value);
      parsed = BigInt(value);
    } else {
      parsed = value;
    }
  } catch (error) {
    if (error instanceof InvalidQyooIdError) throw error;
    throw new InvalidQyooIdError(value);
  }
  if (parsed < 0n || parsed > MAX_QYOO_ID) throw new InvalidQyooIdError(value);
  return Number(parsed);
}
